import React, {Component} from "react";
import "./InquiriesPerUser.css";
import InquiriesPerUserTable from "./InquiriesPerUserTable/InquiriesPerUserTable";
import InquiriesPerUserTitleBar from "./InquiriesPerUserTitleBar/InquiriesPerUserTitleBar";
import axios from "axios";
import ReactGA from "react-ga";
import {GOOGLE_ANALYTICS_CODE} from "../../../configuration";



class InquiriesPerUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.userId
            // userId: this.props.match.params.id
        };
    }

    getFilteredInquiries =()=>{

    }


    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);
        return (
            <div className="inquiry-per-user-content">
                <div className="inquiry-per-user-div">
                    <InquiriesPerUserTitleBar userId={this.state.userId}/>
                    <br/>
                    <InquiriesPerUserTable userId={this.state.userId} getAll = {this.getFilteredInquiries}/>
                </div>

            </div>
        )
    }
}

export default InquiriesPerUser;


// WEBPACK FOOTER //
// ./src/components/Admin/InquiriesPerUser/InquiriesPerUser.js